import React from 'react';

export default ({children, halfColumn, key, featured}) => {
  return (
    <div key={key} className={"col mx-auto center article--home col-12" + (featured ? ' post--featured' : '')}>
      { children }
    </div>
  )
}



// WEBPACK FOOTER //
// ./src/components/Post.js